import { useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Descriptions, Form, Row, Col, Button, InputNumber, Input, message } from 'antd';
import Helper from '../../utils/helper';
import { stepperMoving } from "../../stores/actions";
import { request } from '../../../../shared/src/apis';
import { errorMessage } from "../../utils/commonStringsConsts";
import { collectAndCancelApi } from '../../utils/apisConsts';

export const ViewCollectAndCancel = () => {
    const [loader, setLoader] = useState(false);
    const refForm: { current: any } = useRef();
    const reqInfo = useSelector((state: any) => state.actionsReducer.info)
    const dispatch = useDispatch()
    const submit = async (values: any) => {
        setLoader(true);
        try {
            const payloadData = {
                advanceID: reqInfo?.advanceID,
                amount: values?.collectedAmount,
                ref: values?.collectionReference,
            };

            const apiData: any = await dispatch(request({ method: 'POST', url: `${collectAndCancelApi}`, data: payloadData }));
            const res = await apiData?.data;

            if (res?.status === 201 || res?.status === 200) {
                message.success(res?.message, 5);
                dispatch(stepperMoving(0));
            } else {
                message.error(res?.message, 5);
            }
        } catch (error) {
            message.error(errorMessage, 5);
        } finally {
            setLoader(false);
        }
    };
    return (
        <>
            <Descriptions
                title={`Request#${reqInfo?.advanceID}`}
                bordered
                size={'small'}>
                <>
                    <Descriptions.Item label='User ID'>{reqInfo?.userID}</Descriptions.Item>
                    <Descriptions.Item label='User name'>{reqInfo?.name}</Descriptions.Item>
                    <Descriptions.Item label='User company'>{reqInfo?.companyName}</Descriptions.Item>
                    <Descriptions.Item label='Request Date'>{reqInfo?.dateOfRequest}</Descriptions.Item>
                    <Descriptions.Item label='Request Amount'>{`${reqInfo?.requestedAmount} ${reqInfo?.amountCurrency}`}</Descriptions.Item>
                    <Descriptions.Item label='Transfer Date'>{Helper.changeDateFormat(reqInfo?.transferDate)}</Descriptions.Item>
                </>
            </Descriptions>
            <Form name="nest-messages" ref={refForm} style={{ marginTop: '20px' }} onFinish={submit}>
                <Row gutter={[16, 16]}>
                    <Col span='12'>
                        <div>
                            <label htmlFor="collectedAmount">
                                <span>*</span>
                                Collected Amount
                            </label>
                            <Form.Item name={['collectedAmount']} rules={[{
                                type: 'number', min: 1, max: 10000000,
                                required: true, message: 'Collected Amount is mandatory'
                            }]}>
                                <InputNumber placeholder='Enter the Collected Amount' style={{ width: '100%' }} />
                            </Form.Item>
                        </div>
                    </Col>
                    <Col span='12'>
                        <div>
                            <label htmlFor="collectionReference">
                                <span>*</span>
                                Collection Reference
                            </label>
                            <Form.Item name={['collectionReference']} rules={[{
                                required: true, message: 'Collection Reference is mandatory'
                            }]}>
                                <Input placeholder='Enter the Collection Reference' />
                            </Form.Item>
                        </div>
                    </Col>
                    <Col span='24' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" style={{ minWidth: '100px' }} loading={loader}>
                                Submit
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </>
    )
}
